import { css } from 'styled-components'

const uiList = css`
  list-style: none;
  padding-left: 0;
  margin-left: 0;
`

export default uiList



// WEBPACK FOOTER //
// ./src/components/styles/mixins/uiList.js